import React from 'react';
import "./style.css"
import { Bar, Line } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { color, offset } from 'highcharts';
import { Typography } from '@mui/material';
ChartJS.register(...registerables);
ChartJS.register(ChartDataLabels);

let colors = [
    "#74ADE4",
    "#3FB68E",
    "#ED8D61",
    "#F36A94",
    "#AA7ED7",
    "#3DB5C5",
]

const SFLineChart2 = ({ type, format, title, xAxisLabel, yAxisLabel, labels, dataArr, min, max, stepSize, selectedDataArr, labelsMaxCount, labelsArr, width, selectedTopic, datasetsProp, chart, tootltipLabel }) => {

    const plugin = {
        id: 'customCanvasBackgroundColor',
        beforeDraw: (chart, args, options) => {
            const { ctx, chartArea } = chart;
            const borderRadius = options.borderRadius || 10; // Default border radius
            const { top, left, bottom, right } = chartArea;

            ctx.save();

            // Set the background color and prepare for rounded corners
            // ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = options.color || 'white';

            // Draw a rectangle with rounded corners
            ctx.beginPath();
            ctx.moveTo(left + borderRadius, top);
            ctx.arcTo(right, top, right, bottom, borderRadius);
            ctx.arcTo(right, bottom, left, bottom, 0);
            ctx.arcTo(left, bottom, left, top, borderRadius);
            ctx.arcTo(left, top, right, top, 0);
            ctx.closePath();
            ctx.fill();

            // Set line properties
            const lineColor = options.lineColor || 'white'; // Color of the lines
            const lineWidth = options.lineWidth || 2; // Width of the lines
            const lineSpacing = options.lineSpacing || 20; // Space between the lines

            ctx.strokeStyle = lineColor;
            ctx.lineWidth = lineWidth;

            // Draw horizontal lines from left to right inside the rounded rectangle
            for (let y = top + lineSpacing; y < bottom; y += lineSpacing) {
                ctx.beginPath();
                ctx.moveTo(left + borderRadius / 2, y); // Start inside the border radius
                ctx.lineTo(right - borderRadius / 2, y); // End inside the border radius
                ctx.stroke();
            }

            // Draw vertical lines from top to bottom inside the rounded rectangle
            for (let x = left + lineSpacing; x < right; x += lineSpacing) {
                ctx.beginPath();
                ctx.moveTo(x, top + borderRadius / 2); // Start inside the border radius
                ctx.lineTo(x, bottom - borderRadius / 2); // End inside the border radius
                ctx.stroke();
            }

            ctx.restore();
        },
    };


    const chartAreaBorder = {
        id: 'chartAreaBorder',
        beforeDraw(chart, args, options) {
            const { ctx, chartArea: { left, top, width, height } } = chart;
            const borderRadius = options.borderRadius || 10; // Default border radius

            ctx.save();
            ctx.strokeStyle = options.borderColor || 'black'; // Default border color
            ctx.lineWidth = options.borderWidth || 2; // Default border width

            // Draw only the vertical left line and horizontal bottom line with a rounded bottom-left corner
            ctx.beginPath();

            // Vertical left line
            ctx.moveTo(left, top);
            ctx.lineTo(left, top + height - borderRadius);

            // Bottom left corner with border radius
            ctx.arcTo(left, top + height, left + borderRadius, top + height, borderRadius);

            // Horizontal bottom line
            ctx.lineTo(left + width, top + height);

            ctx.stroke();
            ctx.restore();
        }
    };


    const options = {
        responsive: true,
        // spanGaps: true,
        maintainAspectRatio: false,
        hover: {
            mode: null // Disables hover effects
        },
        elements: {
            line: {
                borderJoinStyle: 'round',
                borderCapStyle: 'round',
            }
        },
        plugins: {
            tooltip: {
                // mode:'index',
                intersect: false,
                enabled: true,
                displayColors: false,
                callbacks: {
                    title: (tooltipItems) => {
                        return '';
                        // Optionally show x-axis value as title
                        const item = tooltipItems[0];
                        return item.label || ''; // this refers to the label of the x-axis tick
                    },
                    label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const value = tooltipItem.raw;
                        const label = tootltipLabel || dataset.label || chart || 'Category';
                        if (label) {
                            return `${label}: ${value}`;
                        }
                        return '';
                    }
                },

            },
            labels: {
                enabled: false,
            },

            legend: {
                display: false,
            },
            chartAreaBorder: {
                borderColor: '#484848',
                borderWidth: 3,
            },
            customCanvasBackgroundColor: {
                color: '#DFE3E5',
                lineColor: 'white',
                lineWidth: 1,
                lineSpacing: 25,
            },
            title: {
                display: false,
                text: title,
                font: {
                    size: 14, // Set the font size here
                    weight: 'bold', // Set the font weight here
                },
                color: 'black'
            },

        },
        layout: {
            padding: 0
        },
        animation: false,
        scales: {
            x: {
                offset: true,
                title: {
                    display: true,
                    text: xAxisLabel,
                    font: {
                        size: 12,
                        weight: 600,
                    }
                },
                grid: {
                    drawBorder: false,
                    lineWidth: 0,
                },
                ticks: {
                    color: 'black',
                    autoSkip: false,
                    // stepSize: 10,
                    font: {
                        size: 12,
                        weight: 500,
                    },
                },
                min: 0,
            },
            y: {
                offset: true,
                type: type,
                beginAtZero: true,
                grid: {
                    drawBorder: false,
                    lineWidth: 0,
                },
                title: {
                    display: true,
                    text: yAxisLabel,
                    font: {
                        size: 14,
                        weight: 600,
                        color: "black"
                    }
                },
                min: min,
                // max: max,
                ticks: {
                    stepSize: stepSize,
                    color: 'black',
                    font: {
                        size: 12,
                        weight: 500,
                    },
                }
            },
        },

    }

    let datasets = [];
    if (datasetsProp) {
        datasets = datasetsProp;
    } else {
        // console.debug("dataArr>>??", dataArr)
        datasets.push({
            // data: [...dataArr, ...dataArr, ...dataArr, ...dataArr, ...dataArr],
            data: dataArr,
            borderColor: colors[0],
            borderWidth: 10,
            pointRadius: 4,
            pointBorderWidth: 0,
            pointBackgroundColor: "#333",
            pointBorderColor: '#333',
            pointStyle: false,
            order: 3,
            datalabels: {
                display: false,
                color: 'white',
                backgroundColor: '#222',
                borderRadius: 15,
                padding: {
                    top: 2,
                    right: 4,
                    bottom: 2,
                    left: 4,
                },
                anchor: 'end',
                align: 'right',
                font: {
                    weight: 'bold',
                },
                formatter: (value) => {
                    return `${value}%`
                }
            },
        });
    }

    let labelsDataArr = labelsArr ? labelsArr : Array.from({ length: labelsMaxCount }).map((_, index) => index + 1)
    let data = {
        labels: labelsDataArr,
        datasets: datasets,
    };


    const barWidth = 40; // Width for each bar
    const totalBars = data?.labels?.length || 0;
    let dynamicWidth = totalBars * barWidth;

    const containerStyle = {
        width: '300px',       // Outer container fills available space
        height: '300px',
        overflowX: 'auto',
        overflowY: 'hidden',
        position: 'relative',
    };

    const chartBodyStyle = {
        width: `${dynamicWidth}px`,
        minWidth: "300px",
        height: '100%',
        position: 'relative',
    };

    // console.debug("dynamicWidth>>??", dynamicWidth)
    // if (dynamicWidth < 350) {
    //     dynamicWidth = 350;
    // }
    return (
        <div style={{ width: "300px", height: "300px" }}>
            {title}
            <div className="chart-container" style={containerStyle}>
                <div className="chart-container-body" style={chartBodyStyle}>
                    <Line
                        plugins={[ChartDataLabels, plugin, chartAreaBorder]}
                        options={{ ...options }}
                        data={data}
                        height={"100%"}
                        width={"100%"}
                    // width={dynamicWidth}
                    />
                </div>
            </div>

        </div>
    );

}

export default SFLineChart2;
